import Marquee from "react-fast-marquee";

const ITEMS = [
  "Mathematics",
  "Science",
  "Physics · CBSE",
  "Physics · AHSEC",
  "Doubt Clearing",
  "Free Handouts",
  "Small Batches",
  "Exam Ready",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="bg-flame text-white py-4 border-y border-white/10 select-none">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-extrabold uppercase tracking-tight text-xl sm:text-2xl px-6">
              {t}
            </span>
            <span className="text-white/70 text-xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
